import { Directive, HostListener, Input, OnDestroy } from '@angular/core';
import { MenuAction } from '@shared/interfaces/header/menu-action';
import { ContextMenuService } from '@shared/directives/context-menu/context-menu.service';


@Directive({
  selector: '[appContextMenu]',
})
export class ContextMenuDirective implements OnDestroy {
  /**
   * List of menu actions to display in the context menu
   */
  @Input() public appContextMenu!: MenuAction[];
  @Input() public contextMenuElement?: any;

  /**
   * Handle context menu click event
   * @param event
   */
  @HostListener('contextmenu', ['$event'])
  public onClick(event: Event): void {
    if (event instanceof MouseEvent) {
      if (this.appContextMenu.length === 0) return;

      event.preventDefault();
      event.stopPropagation();

      this.contextMenuService.openMenu(event.clientX, event.clientY, this.appContextMenu);
    }
  }

  /**
   * Register Click Outside
   * @param event
   */
  @HostListener('document:click', ['$event'])
  public clickOutside(event: Event): void {
    if (event instanceof MouseEvent) {
      this.contextMenuService.closeMenu();
    }
  }

  /**
   * Handle Escape key press
   * Closes the context menu if it's open
   */
  @HostListener('document:keydown.escape', ['$event'])
  public onEscape(event: Event): void {
    if (event instanceof KeyboardEvent) {
      event.preventDefault();
    }
    this.closeMenu();
  }

  /**
   * Close Context Menu on Blur
   */
  @HostListener('window:blur', ['$event'])
  public onBlur(event: FocusEvent): void {
    this.closeMenu();
  }

  @HostListener('window:focus', ['$event'])
  public onFocus(event: FocusEvent): void {
    this.closeMenu();
  }

  constructor(
    private readonly contextMenuService: ContextMenuService,
  ) {}

  public ngOnDestroy(): void {
    this.closeMenu()
  }

  private closeMenu() {
    if (this.contextMenuService.open()) {
      this.contextMenuService.closeMenu();
    }
  }
}
